






































import {Component, Vue} from "vue-property-decorator"
import Gravatar from "@/components/Gravatar.vue"
import Dialog from "@/components/Dialog.vue"
import SiteImage from "@/components/SiteImage.vue"
import {vxm} from "@/store"
import {Site} from "@/interface"

@Component({components: {Gravatar, Dialog, SiteImage}})
export default class App extends Vue {

  // private sub_open: boolean = false

  private dialog: boolean = false

  get sites() {
    return vxm.app.sites
  }

  get site_id() {
    return vxm.app.selected_site_id
  }

  get selected_site(): Site | null {
    return vxm.app.sites.find(site => site.id === vxm.app.selected_site_id) || null
  }

  set site_id(val: number) {
    vxm.app.setSiteId(val)
  }

  onSelectSite(site_id: number) {
    vxm.app.setSiteId(site_id)
    this.dialog = false
    location.reload()
  }

  async onClickMenu() {
    vxm.ui.show_menu
      ? await vxm.ui.hideSideNavi()
      : await vxm.ui.showSideNavi()
  }
}
